
import { mapState } from 'vuex'
import StoreTile from '@/components/storeLocator/StoreTile'
export default {
  components: {
    StoreTile,
  },
  computed: {
    ...mapState('storeLocator', ['nearestStores']),
  },
}
